import { useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Step2.css";

const Step2 = () => {
  const navigate = useNavigate();

  const onLogo1ContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onButtonDesktopSecondaryContainerClick = useCallback(() => {
    navigate("/step1");
  }, [navigate]);

  const onButtonDesktopSecondaryContainer1Click = useCallback(() => {
    navigate("/step3");
  }, [navigate]);

  const onButtonDesktopSecondaryContainer3Click = useCallback(() => {
    navigate("/step1");
  }, [navigate]);

  return (
    <div className="step2-div">
      <div className="frame-div48">
        <div className="logo1-div3" onClick={onLogo1ContainerClick}>
          <img className="vector-icon80" alt="" src="../vector80.svg" />
          <img className="vector-icon81" alt="" src="../vector56.svg" />
          <img className="vector-icon82" alt="" src="../vector57.svg" />
          <img className="vector-icon83" alt="" src="../vector58.svg" />
          <img className="vector-icon84" alt="" src="../vector84.svg" />
          <img className="vector-icon85" alt="" src="../vector60.svg" />
          <img className="vector-icon86" alt="" src="../vector61.svg" />
          <img className="vector-icon87" alt="" src="../vector62.svg" />
          <img className="vector-icon88" alt="" src="../vector63.svg" />
          <img className="vector-icon89" alt="" src="../vector89.svg" />
          <img className="vector-icon90" alt="" src="../vector90.svg" />
          <img className="vector-icon91" alt="" src="../vector91.svg" />
          <img className="vector-icon92" alt="" src="../vector67.svg" />
          <img className="vector-icon93" alt="" src="../vector93.svg" />
          <img className="vector-icon94" alt="" src="../vector69.svg" />
          <img className="vector-icon95" alt="" src="../vector95.svg" />
          <img className="vector-icon96" alt="" src="../vector71.svg" />
          <img className="vector-icon97" alt="" src="../vector72.svg" />
          <img className="vector-icon98" alt="" src="../vector73.svg" />
          <img className="vector-icon99" alt="" src="../vector99.svg" />
          <img className="vector-icon100" alt="" src="../vector100.svg" />
          <img className="vector-icon101" alt="" src="../vector101.svg" />
          <img className="vector-icon102" alt="" src="../vector102.svg" />
          <img className="vector-icon103" alt="" src="../vector103.svg" />
          <img className="vector-icon104" alt="" src="../vector104.svg" />
          <b className="shuleeazy-b3">ShuleEazy</b>
        </div>
      </div>
      <div className="frame-div49">
        <b className="step-2-of-3">Step 2 of 3</b>
        <b className="you-want-to-enroll-in">You want to enroll in:</b>
      </div>
      <div className="frame-div50">
        <div className="card-div4">
          <div className="frame-div51">
            <img className="music-icon" alt="" src="../school1.svg" />
          </div>
          <b className="parent-b4">School</b>
          <div className="frame-div52">
            <div className="step-2-of-3">
              <p className="full-time-academic-program">
                Full-time academic program:
              </p>
              <p className="classes-p">Competency Based Curriculum</p>
            </div>
          </div>
          <Form.Check
            className="ellipse-formcheck4"
            name="step2"
            id="step2"
            type="radio"
          />
        </div>
        <div className="card-div4">
          <div className="frame-div51">
            <img className="music-icon" alt="" src="../music.svg" />
          </div>
          <b className="parent-b4">After school</b>
          <div className="frame-div52">
            <div className="step-2-of-3">
              <p className="full-time-academic-program">{`Elective, skill based, After school `}</p>
              <p className="classes-p">classes</p>
            </div>
          </div>
          <Form.Check
            className="ellipse-formcheck4"
            name="step2"
            id="step2"
            type="radio"
          />
        </div>
        <div className="card-div4">
          <div className="frame-div51">
            <img className="music-icon" alt="" src="../mentor.svg" />
          </div>
          <b className="parent-b4">Mentorship</b>
          <div className="frame-div52">
            <div className="step-2-of-3">
              <p className="full-time-academic-program">
                Mentorship sessions with experts
              </p>
              <p className="classes-p"> in the industry</p>
            </div>
          </div>
          <Form.Check
            className="ellipse-formcheck4"
            name="step2"
            id="step2"
            type="radio"
          />
        </div>
        <div className="card-div4">
          <div className="frame-div51">
            <img className="music-icon" alt="" src="../all.svg" />
          </div>
          <b className="parent-b4">All</b>
          <div className="frame-div52">
            <div className="step-2-of-3">
              <p className="full-time-academic-program">
                Interested in school, after school
              </p>
              <p className="classes-p">and mentorship sessions</p>
            </div>
          </div>
          <Form.Check
            className="ellipse-formcheck4"
            name="step2"
            id="step2"
            type="radio"
          />
        </div>
      </div>
      <div className="frame-div59">
        <div
          className="buttondesktopsecondary-div"
          onClick={onButtonDesktopSecondaryContainerClick}
        >
          <b className="save-and-next8">Prev</b>
        </div>
        <div
          className="buttondesktopsecondary-div"
          onClick={onButtonDesktopSecondaryContainer1Click}
        >
          <b className="save-and-next8">NEXT</b>
        </div>
      </div>
      <div
        className="buttondesktopsecondary-div2"
        onClick={onButtonDesktopSecondaryContainer3Click}
      >
        <div className="buttondesktopsecondary-div3">
          <b className="save-and-next8">RESET</b>
        </div>
      </div>
    </div>
  );
};

export default Step2;
